module.exports = __webpack_public_path__ + "static/media/500px.59c02a77.svg";